import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";
import { MainSponsor } from "@/components/MainSponsor";
import { NetworkLogo } from "@/components/NetworkLogo";
import { SplashScreen } from "@/components/SplashScreen";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function Layout() {
  // Botones flotantes de transmisión (Televisa Occidente + Sponsor Main).
  // Inhabilitados a petición del cliente — se conserva el código, solo no se renderizan.
  const SHOW_BROADCAST_BUGS = false;

  return (
    <div className="relative min-h-screen bg-cream">
      <div className="grain-overlay" aria-hidden="true" />
      <SmoothScroll />
      <Navbar />
      <main className="pt-20 sm:pt-24">
        <Outlet />
      </main>
      <Footer />
      <SplashScreen />
      {SHOW_BROADCAST_BUGS && (
        <>
          <MainSponsor variant="bug" />
          <div className="fixed bottom-24 left-4 z-40" data-testid="network-bug">
            <div className="rounded-2xl bg-ink/90 px-3.5 py-2.5 shadow-[0_10px_30px_rgba(0,0,0,0.25)] ring-1 ring-white/10 backdrop-blur-md">
              <NetworkLogo theme="dark" compact />
            </div>
          </div>
        </>
      )}
      <WhatsAppButton />
      <Toaster position="bottom-center" />
    </div>
  );
}
